import React, { useContext, useEffect, useRef, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LocaleContext } from 'routes/Router';
import CallIcon from 'assets/images/Dashboard/call.svg';
import MailIcon from 'assets/images/Dashboard/mail.svg';
import DefaultImage from 'assets/images/Dashboard/default-list.svg';
import { ClearTokenRedirectLogin } from 'utils/general';
import { getProfileSectionData } from 'store/doctorProfileSection/doctorProfileSectionAction';
import EditIcon from 'assets/images/Dashboard/edit-profile.svg';
import CommonModal from 'components/commom/Modal';
import CloseIcon from 'assets/images/Dashboard/close-profile.svg';
import LabelWithInput from 'components/commom/LabelWithInput';
import ReusableButton from 'components/commom/Button';
import { updateProfileSectionData } from 'store/updateDoctorProfile/updateDotorProfileAction';
import ReusableTabs from 'components/commom/Tab';
import AboutTab from './AboutTab';
import AppointmentTab from './AppointmentTab';
import ScheduleTab from './ScheduleTab';
import { useDropzone } from 'react-dropzone';
import { registerUploadAction } from 'store/registerUpload/registerUploadAction';
import UploadIcon from 'assets/images/WithoutLogin/camera.svg';
import EditIconProfie from 'assets/images/Dashboard/edit-profile-modal.svg';
import Shimmer from 'components/commom/Shimmer';
import ProfileStatus from 'assets/images/Dashboard/profile-status.svg';
import DocumentIcon from 'assets/images/Dashboard/delete-icon.svg';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CustomPopover from 'components/commom/Popover';
import { deleteDoctorData } from 'store/deleteDoctor/deleteDoctorAction';
import moment from 'moment';
import Download from 'assets/images/Dashboard/download.svg';
import CommonToast from 'components/commom/CommonToast';
import { getReminderCallAPI } from 'store/getReminder/action';

const DoctorProfile = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const dispatch = useDispatch();
  const { locale } = useContext(LocaleContext);
  const { showToast } = CommonToast();
  const fileInputRef = useRef(null);
  const [profileData, setProfileData] = useState([]);
  const [profileModal, setProfileModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [deleteMdoal, setDeleteModal] = useState(false);
  const [formData, setFormData] = useState({
    profileUpload: '',
    profileUploadId: '',
    fullName: '',
    mobileNumber: '',
    email: '',
    address: '',
    licenceNumber: '',
    licenceExpiryDate: '',
    licenceUpload: '',
    licenceUploadId: '',
  });
  const [formDataDisable, setFormDataDisable] = useState({
    profileUpload: '',
    profileUploadId: '',
    fullName: '',
    address: '',
  });
  const [tab, setTab] = useState(1);
  const [tabData, setTabData] = useState([]);
  const [remindContent, setRemindContent] = useState('Remind Admin');

  const updateProfileReducer = useSelector(
    (state) => state?.updateProfileSectionDataReducer?.loading
  );

  const getProfileReducer = useSelector(
    (state) => state?.profileSectionDataReducer?.loading
  );

  const profileReducer = useSelector(
    (state) => state?.registerUploadReducer?.loading
  );

  const profileDisableData = useSelector(
    (state) => state?.profileSectionDataReducer?.users?.data
  );

  const deleteLoading = useSelector(
    (state) => state?.deleteDoctorReducer?.loading
  );

  const loginData = useSelector((state) => state?.loginReducer?.users);

  const reminderLoader = useSelector(
    (state) => state?.getReminderReducer?.loading
  );

  useEffect(() => {
    getProfileSetion();
  }, []);

  const getProfileSetion = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setProfileData(res?.data);
        handleSuccess(res);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getProfileSectionData(external));
  };

  const handleSuccess = (response) => {
    setFormData((prevState) => ({
      ...prevState,
      profileUpload: response?.data?.profile_image,
      fullName: response?.data?.full_name,
      mobileNumber: `${response?.data?.country_code} ${response?.data?.contact_number}`,
      email: response?.data?.email,
      address: response?.data?.address?.address_line1,
      licenceNumber: response?.data?.licence_number,
      licenceExpiryDate: response?.data?.licence_expiry_date,
      licenceUpload: response?.data?.medical_licence,
      licenceUploadId: '',
    }));
    setFormDataDisable((prevState) => ({
      ...prevState,
      profileUpload: response?.data?.profile_image,
      fullName: response?.data?.full_name,
      address: response?.data?.address?.address_line1,
    }));
  };

  useEffect(() => {
    if (profileDisableData) {
      if (profileDisableData?.title?.id === 10) {
        setTabData([]);
      } else {
        const tabs = [
          { label: intl.formatMessage({ id: 'About' }) },
          { label: intl.formatMessage({ id: 'Schedule' }) },
          { label: intl.formatMessage({ id: 'Appointment History' }) },
        ];
        setTabData(tabs);
      }
    }
  }, [profileDisableData]);

  const handleProfileModal = () => {
    setProfileModal(true);
  };

  const handleCloseProfile = () => {
    setProfileModal(false);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: '.jpg, .png, .jpeg',
    onDrop: (acceptedFiles) => {
      let formData = new FormData();
      acceptedFiles.forEach((file) => {
        formData.append('filePath', file);
      });
      const external = {
        run: true,
        handleFunction: (res) => {
          setFormData((prev) => ({
            ...prev,
            profileUpload: res?.data?.[0]?.filePath,
            profileUploadId: res?.data?.[0]?.id,
          }));
          showToast(res?.message, 'success');
        },
        error: true,
        handleErrorFunction: (res) => showToast(res?.message, 'error'),
      };
      dispatch(registerUploadAction(formData, external));
    },
  });

  const handleInputChange = (event) => {
    const { name, value } = event?.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSaveProfile = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        setProfileModal(false);
        setAnchorEl(null);
        getProfileSetion();
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    let body = {
      full_name: formData?.fullName,
      mobile_number: formData?.mobileNumber,
      email: formData?.email,
      address: {
        address_line1: formData?.address,
      },
      licence_number: formData?.licenceNumber,
      registration_number: formData?.licenceNumber,
      expiry_date: formData?.licenceExpiryDate,
    };
    if (formData?.profileUploadId === '') {
      delete body['profile_image_id'];
    } else {
      body['profile_image_id'] = +formData?.profileUploadId;
    }

    if (formData?.licenceUploadId === '') {
      delete body['medical_licence_id'];
    } else {
      body['medical_licence_id'] = +formData?.licenceUploadId;
    }

    dispatch(updateProfileSectionData(external, body));
  };

  // const tabData = [
  //   { label: intl.formatMessage({ id: 'About' }) },
  //   { label: intl.formatMessage({ id: 'Schedule' }) },
  //   { label: intl.formatMessage({ id: 'Appointment History' }) },
  // ];

  const handleTabChange = (val) => {
    setTab(val);
  };

  const getUpdateValue = (value) => {
    if (value) {
      getProfileSetion();
    }
  };

  const handlePopoverClick = (event, item) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const PopoverData = [
    {
      label: <FormattedMessage id="Edit Profile" />,
      className: 'fs-16 fc-C56616 lh-20 family_outfit_medium_500 m-0',
      icon: (
        <Image
          src={EditIcon}
          alt="icon"
          style={{ marginRight: '5px', marginTop: '-5px' }}
        />
      ),
      onClick: () => handleProfileModal(),
    },
    {
      label: <FormattedMessage id="Delete" />,
      className: 'fs-16 fc-292D32 lh-20 family_outfit_medium_500 m-0',
      icon: (
        <Image
          src={DocumentIcon}
          alt="icon"
          style={{ marginRight: '5px', marginTop: '-5px' }}
        />
      ),
      onClick: () => handleDeleteModal(),
    },
  ];

  const handleDeleteModal = () => {
    setDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
  };

  const handleDelete = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        ClearTokenRedirectLogin(navigate);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(deleteDoctorData(external, profileData?.role));
  };

  const handleReminder = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setRemindContent('Mail Sent');
        setTimeout(() => {
          setRemindContent('Remind Admin');
        }, 2000);
        showToast(res?.message, 'success');
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getReminderCallAPI(external));
  };

  const handleFileUpload = (e) => {
    if (e.target.files[0]) {
      const external = {
        run: true,
        handleFunction: (res) => {
          setFormData((prev) => ({
            ...prev,
            licenceUpload: res?.data?.[0]?.filePath,
            licenceUploadId: res?.data?.[0]?.id,
          }));
          showToast(res?.message, 'success');
        },
        error: true,
        handleErrorFunction: (res) => showToast(res?.message, 'error'),
      };

      const Data = new FormData();
      Data.append('filePath', e.target.files[0]);
      Data.append('fileType', 'I');

      dispatch(registerUploadAction(Data, external));
    }
  };

  const handleChooseFile = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainer lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <Row className="bc-FFFFFF m-0 p-24 border-1 bColor-EFE3D7">
            <Col xs={12} md={12} className="p-0">
              <div className="flex justify-between">
                <div className="fs-16 lh-16 fc-292D32 family_outfit_medium_500">
                  <FormattedMessage id="Doctor Profile" />
                </div>

                <div>
                  <MoreVertIcon
                    aria-describedby={id}
                    style={{ fill: '#3C1053', cursor: 'pointer' }}
                    onClick={(e) => handlePopoverClick(e)}
                  />
                  <CustomPopover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    handleClose={handlePopoverClose}
                    options={PopoverData}
                  />
                </div>
              </div>
            </Col>
            <Col xs={12} md={12} className="mt-4 p-0 bColor-D6DDE6">
              <Row>
                <Col lg={6}>
                  <Stack
                    direction="horizontal"
                    gap={3}
                    className="flex items-start"
                  >
                    {getProfileReducer ? (
                      <Shimmer width="88px" height="88px" borderRadius="50%" />
                    ) : (
                      <Image
                        src={
                          profileData?.profile_image !== ''
                            ? profileData?.profile_image
                            : DefaultImage
                        }
                        alt={'icon'}
                        style={{
                          height: '88px',
                          width: '88px',
                          borderRadius: '50%',
                        }}
                      />
                    )}
                    <div className="p-0 m-0">
                      <div className="fs-18 lh-2268 fc-202224 family_outfit_medium_500">
                        {getProfileReducer ? (
                          <Shimmer width="150px" height="20px" />
                        ) : (
                          profileData?.full_name
                        )}
                      </div>
                      <div className="fs-16 lh-201 pt-8 fc-998A7B family_outfit_regular_400 break-all ...">
                        {getProfileReducer ? (
                          <Shimmer width="150px" height="20px" />
                        ) : (
                          profileData?.higher_qualification?.qualification
                        )}
                      </div>
                      <div className="p-0 m-0">
                        <Stack
                          direction="horizontal"
                          gap={5}
                          className="items-center pt-12"
                        >
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center"
                          >
                            {getProfileReducer ? (
                              <Shimmer width="250px" height="20px" />
                            ) : (
                              <>
                                <Image src={CallIcon} alt="icon" />
                                <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400">
                                  {`${profileData?.country_code} ${profileData?.contact_number}`}
                                </div>
                              </>
                            )}
                          </Stack>
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center"
                          >
                            {getProfileReducer ? (
                              <Shimmer width="250px" height="20px" />
                            ) : (
                              <>
                                <Image src={MailIcon} alt="icon" />
                                <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 break-all ...">
                                  {profileData?.email}
                                </div>
                              </>
                            )}
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  </Stack>
                  {profileData?.medical_licence !== null &&
                    profileData?.licence_expiry_date !== null && (
                      <div className="pt-24">
                        <Row className="p-0 m-0">
                          <Col sm={7} className="p-0">
                            <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                              Medical License
                            </div>
                            <div className="pt-8 flex pr-20">
                              <a
                                href={profileData?.medical_licence || '#'}
                                download={profileData?.medical_licence}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="truncate flex-1 underline fs-16 fc-5B88E9 family_outfit_regular_400"
                              >
                                {getProfileReducer ? (
                                  <Shimmer
                                    width="150px"
                                    height="20px"
                                    marginTop={'8px'}
                                  />
                                ) : (
                                  profileData?.medical_licence && (
                                    <>
                                      {profileData?.medical_licence
                                        .split('/')
                                        .pop()}
                                    </>
                                  )
                                )}
                              </a>
                              <span>
                                <a
                                  href={profileData?.medical_licence || '#'}
                                  download={profileData?.medical_licence}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <Image
                                    src={Download}
                                    alt="icon"
                                    className="pl-2"
                                  />
                                </a>
                              </span>
                            </div>
                          </Col>

                          <Col sm={4} className="p-0">
                            <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                              Licence Expire Date
                            </div>
                            {getProfileReducer ? (
                              <Shimmer
                                width="150px"
                                height="20px"
                                marginTop={'8px'}
                              />
                            ) : (
                              <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                                {moment(
                                  profileData?.licence_expiry_date
                                ).format('DD MMM YYYY')}
                              </div>
                            )}
                          </Col>
                        </Row>
                      </div>
                    )}
                </Col>

                <Col lg={6}>
                  <div className="pt-20 lg:pt-0">
                    <Row className="">
                      <Col sm={4}>
                        <div className="fs-14 lh-176 family_outfit_regular_400 fc-998A7B">
                          Title
                        </div>
                        {getProfileReducer ? (
                          <Shimmer width="100px" height="20px" />
                        ) : (
                          <div className="fs-16 pt-8 lh-201 family_outfit_regular_400 fc-202224 break-all ...">
                            {profileData?.title?.name}
                          </div>
                        )}
                      </Col>
                      <Col sm={4} className="p-0">
                        <div className="fs-14 lh-176 family_outfit_regular_400 fc-998A7B">
                          Provider Type
                        </div>
                        {getProfileReducer ? (
                          <Shimmer width="100px" height="20px" />
                        ) : (
                          <div className="fs-16 pt-8 lh-201 family_outfit_regular_400 fc-202224 break-all ...">
                            {profileData?.provider_type?.name}
                          </div>
                        )}
                      </Col>

                      <Col sm={4} className="p-0">
                        {(profileData?.doctor_verification?.in_review ===
                          true ||
                          loginData?.data?.status === 'Pending') && (
                          <div>
                            <Stack
                              direction="horizontal"
                              gap={2}
                              className="items-center"
                            >
                              <Image src={ProfileStatus} alt="icon" />
                              <div className="fs-14 lh-176 family_outfit_regular_400 fc-998A7B">
                                Profile Status
                              </div>
                            </Stack>
                            <div className="flex gap-[15px] items-center fs-16 pt-8 lh-201 family_outfit_regular_400 fc-202224 break-all ...">
                              {getProfileReducer ? (
                                <Shimmer width="100px" height="20px" />
                              ) : (
                                <>
                                  {profileData?.doctor_verification
                                    ?.in_review === true
                                    ? 'In Review'
                                    : loginData?.data?.status === 'Pending'
                                      ? 'Pending'
                                      : ''}
                                  {loginData?.data?.status === 'Pending' && (
                                    <ReusableButton
                                      fullWidth={false}
                                      variant="contained"
                                      color="#F5F5F5"
                                      fontSize="16px"
                                      fontWeight="500"
                                      padding="12px"
                                      height="40px"
                                      bgColor="#375241"
                                      brColor="#375241"
                                      fontFamily="outfit_regular"
                                      onClick={() => {
                                        !reminderLoader && handleReminder();
                                      }}
                                      loading={reminderLoader}
                                    >
                                      {remindContent}
                                    </ReusableButton>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </div>
                  <div className="pt-20 lg:pt-0">
                    <Row className="w-100">
                      <Col sm={4}>
                        <div className="pt-10">
                          <div className="fs-14 lh-176 family_outfit_regular_400 fc-998A7B">
                            Address
                          </div>
                          {getProfileReducer ? (
                            <Shimmer width="100px" height="20px" />
                          ) : (
                            <div className="fs-16 pt-8 lh-201 family_outfit_regular_400 fc-202224 break-all ...">
                              {profileData?.address?.address_line1}
                            </div>
                          )}
                        </div>
                      </Col>
                      <Col sm={4}>
                        <div className="pt-10">
                          <div className="fs-14 lh-176 family_outfit_regular_400 fc-998A7B">
                            Country
                          </div>
                          {getProfileReducer ? (
                            <Shimmer width="100px" height="20px" />
                          ) : (
                            <div className="fs-16 pt-8 lh-201 family_outfit_regular_400 fc-202224 break-all ...">
                              {profileData?.address?.country?.name}
                            </div>
                          )}
                        </div>
                      </Col>
                      <Col sm={4} className="p-0">
                        <div className="pt-10">
                          <div className="fs-14 lh-176 family_outfit_regular_400 fc-998A7B">
                            State
                          </div>
                          {getProfileReducer ? (
                            <Shimmer width="100px" height="20px" />
                          ) : (
                            <div className="fs-16 pt-8 lh-201 family_outfit_regular_400 fc-202224 break-all ...">
                              {profileData?.address?.state?.name}
                            </div>
                          )}
                        </div>
                      </Col>
                      <Col sm={4}>
                        <div className="pt-10">
                          <div className="fs-14 lh-176 family_outfit_regular_400 fc-998A7B">
                            City
                          </div>
                          {getProfileReducer ? (
                            <Shimmer width="100px" height="20px" />
                          ) : (
                            <div className="fs-16 pt-8 lh-201 family_outfit_regular_400 fc-202224 break-all ...">
                              {profileData?.address?.city?.name}
                            </div>
                          )}
                        </div>
                      </Col>
                      <Col sm={4}>
                        <div className="pt-10">
                          <div className="fs-14 lh-176 family_outfit_regular_400 fc-998A7B">
                            ZIP Code
                          </div>
                          {getProfileReducer ? (
                            <Shimmer width="100px" height="20px" />
                          ) : (
                            <div className="fs-16 pt-8 lh-201 family_outfit_regular_400 fc-202224 break-all ...">
                              {profileData?.address?.zip_code}
                            </div>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          {loginData?.data?.status !== 'Pending' && tabData?.length > 0 && (
            <Col md={12} lg={8} className="p-0">
              <div className="pt-24">
                <ReusableTabs
                  tabs={tabData}
                  defaultTab={tab}
                  currentTab={(val) => handleTabChange(val)}
                  background={'#864629'}
                  color={'#FFFFFF'}
                  tabColor={'#A2A2A2'}
                  completeColor={'#FFFFFF'}
                  boxShadow={'0px 3px 16px 0px #00000014'}
                  disabled={
                    profileDisableData?.doctor_verification?.in_review === true
                  }
                />
              </div>
            </Col>
          )}
          {loginData?.data?.status !== 'Pending' && (
            <>
              {tab === 1 && (
                <AboutTab getUpdateValue={(val) => getUpdateValue(val)} />
              )}
              {tab === 2 && <ScheduleTab />}
              {tab === 3 && <AppointmentTab />}
            </>
          )}
        </Col>
      </Row>

      <CommonModal
        padding={'24px'}
        width={'680px'}
        modalActive={profileModal}
        innerContent={
          <div className="p-0 m-0">
            <Row className="p-0 m-0">
              <Col md={12} className="p-0 m-0">
                <div className="flex justify-between">
                  <div className="fs-24 lh-3024 fc-292D32 family_outfit_semiBold_600">
                    <FormattedMessage id="Edit profile" />
                  </div>
                  <div>
                    <Image
                      src={CloseIcon}
                      alt="icon"
                      className="cursor-pointer ..."
                      onClick={() => handleCloseProfile()}
                    />
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                xxl={12}
                className="m-0 p-0"
              >
                <div className="d-flex justify-center align-items-center pt-16">
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    {isDragActive ? (
                      <p>Drop the files here ...</p>
                    ) : (
                      <>
                        {formData?.profileUpload !== '' ? (
                          profileReducer ? (
                            <Shimmer
                              width="88px"
                              height="88px"
                              borderRadius="50%"
                            />
                          ) : (
                            <div className="uploadPhoto">
                              <Image
                                src={formData?.profileUpload}
                                alt="Uploaded profile"
                                className="uploadPhoto"
                              />
                            </div>
                          )
                        ) : (
                          <div className="uploadPhoto">
                            <div>
                              <Image src={UploadIcon} />
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {!isDragActive && (
                      <Image
                        src={EditIconProfie}
                        alt="edit"
                        className="align-self-center editBtn d-flex justify-content-center"
                        style={{ cursor: 'pointer' }}
                      />
                    )}
                  </div>
                </div>
              </Col>
              <Col md={12} className="p-0">
                <LabelWithInput
                  label="Full Name"
                  placeholder="full Name"
                  name="fullName"
                  type="text"
                  value={formData?.fullName}
                  onChange={(e) => handleInputChange(e, 'providerName')}
                />
              </Col>
              <Col md={6} className="p-0">
                <div className="pt-16">
                  <LabelWithInput
                    label="Mobile number"
                    placeholder="Mobile number"
                    name="mobileNumber"
                    type="text"
                    value={formData?.mobileNumber}
                    onChange={(e) => handleInputChange(e, 'mobileNumber')}
                    disabled={'true'}
                  />
                </div>
              </Col>
              <Col md={6} className="modal-size">
                <div className="pt-16">
                  <LabelWithInput
                    label="Email"
                    placeholder="Email"
                    name="email"
                    type="text"
                    value={formData?.email}
                    onChange={(e) => handleInputChange(e, 'email')}
                    disabled={'true'}
                  />
                </div>
              </Col>
              <Col md={12} className="p-0">
                <div className="pt-16">
                  <LabelWithInput
                    label="Address"
                    placeholder="Address"
                    name="address"
                    type="text"
                    value={formData?.address}
                    onChange={(e) => handleInputChange(e, 'address')}
                  />
                </div>
              </Col>
              <Col md={12} className="p-0">
                <div className="pt-16">
                  <LabelWithInput
                    label="Registration Number"
                    placeholder="Registration Number"
                    name="licenceNumber"
                    type="text"
                    value={formData?.licenceNumber}
                    disabled={
                      !moment().isAfter(
                        moment(profileData?.licence_expiry_date)
                      )
                    }
                    onChange={(e) => handleInputChange(e, 'licenceNumber')}
                  />
                </div>
              </Col>
              <Col md={12} className="p-0">
                <div className="pt-16">
                  <div className="fs-14 lh-176 family_outfit_medium_500 fc-292d32">
                    Medical Licence
                  </div>
                  <div className="pt-8 flex pr-20">
                    <a
                      href={formData?.licenceUpload || '#'}
                      download={formData?.licenceUpload}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="truncate flex-1 underline fs-16 fc-5B88E9 family_outfit_regular_400"
                    >
                      {false ? (
                        <Shimmer
                          width="150px"
                          height="20px"
                          marginTop={'8px'}
                        />
                      ) : (
                        formData?.licenceUpload && (
                          <>{formData?.licenceUpload.split('/').pop()}</>
                        )
                      )}
                    </a>
                    {moment().isAfter(
                      moment(profileData?.licence_expiry_date)
                    ) ? (
                      <>
                        <input
                          type="file"
                          onChange={handleFileUpload}
                          accept=".jpg, .jpeg, .png"
                          ref={fileInputRef}
                          className="d-none"
                        />
                        <ReusableButton
                          fullWidth={false}
                          variant="contained"
                          color="#F5F5F5"
                          fontSize="14px"
                          fontWeight="500"
                          padding="12px 50px"
                          height="44px"
                          bgColor="#375241"
                          brColor="#375241"
                          fontFamily="outfit_medium"
                          onClick={() => {
                            !profileReducer && handleChooseFile();
                          }}
                          loading={profileReducer}
                        >
                          <FormattedMessage id="Re-Upload" />
                        </ReusableButton>
                      </>
                    ) : (
                      <span>
                        <a
                          href={formData?.licenceUpload || '#'}
                          download={formData?.licenceUpload}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Image src={Download} alt="icon" className="pl-2" />
                        </a>
                      </span>
                    )}
                  </div>
                </div>
              </Col>
              <Col md={12} className="p-0">
                <div className="pt-16">
                  <LabelWithInput
                    label="Licence Expiry Date"
                    placeholder="Licence Expiry Date"
                    name="licenceExpiryDate"
                    type="date"
                    value={formData?.licenceExpiryDate}
                    disabled={
                      !moment().isAfter(
                        moment(profileData?.licence_expiry_date)
                      )
                    }
                    onChange={(e) => handleInputChange(e, 'licenceExpiryDate')}
                  />
                </div>
              </Col>

              <Col md={12} className="p-0">
                <div className="pt-40 flex justify-center">
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#F5F5F5"
                    fontSize="16px"
                    fontWeight="500"
                    padding="14px 55px"
                    height="44px"
                    bgColor=" #375241"
                    brColor="transparent"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      !updateProfileReducer &&
                        !profileReducer &&
                        handleSaveProfile();
                    }}
                    loading={updateProfileReducer}
                    // disabled={
                    //   formData?.fullName === formDataDisable?.fullName &&
                    //   formData?.address === formDataDisable?.address &&
                    //   formData?.profileUpload === formDataDisable?.profileUpload
                    // }
                    // disabledBgColor="lightgray"
                    // disabledCursor="not-allowed"
                    disabled={profileReducer}
                  >
                    <FormattedMessage id="Save" />
                  </ReusableButton>
                </div>
              </Col>
            </Row>
          </div>
        }
      />

      <CommonModal
        padding={'24px'}
        width={'560px'}
        modalActive={deleteMdoal}
        innerContent={
          <div className="p-0 m-0">
            <Row className="p-0 m-0">
              <Col md={12} className="p-0 m-0">
                <p className="p-0 m-0 fs-24 fc-292D32 family_outfit_semiBold_600">
                  Are you sure you want to delete your account?
                </p>
              </Col>
              <Col xs={12} md={12} className="mt-3 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center justify-end p-0"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_medium"
                    onClick={() => handleCloseDeleteModal()}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      !deleteLoading && handleDelete();
                    }}
                    loading={deleteLoading}
                  >
                    <FormattedMessage id="Delete" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />
    </div>
  );
};

export default DoctorProfile;
